export const STOP_PAYMENT_WORKFLOW_CONTAINER_TAG_NAME = 'stop-payment-workflow-container';
